import { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiOuterLink } from 'src/components/UI/OuterLink';
import { useBemHelper } from 'src/utils/hooks/useBemHelper';
import { useSelector } from 'react-redux';
import { deCommonCurrentPartnerSelector } from 'src/store/commonPart/selector';

type Props = {
  light?: boolean;
  className?: string;
  href?: string;
};

export const PlusSubscriptionLearnMore: FC<Props> = ({ light, className, href }) => {
  const { t } = useTranslation();
  const bemHelper = useBemHelper('plus-subscription-learn-more');

  const { ComparePricingLink } = useSelector(deCommonCurrentPartnerSelector);

  return (
    <UiOuterLink
      href={href || ComparePricingLink || ''}
      className={classNames(bemHelper([light ? 'color_light' : 'color_dark']), className)}
    >
      {t('plusSubscription.learnMore')}
    </UiOuterLink>
  );
};
